import * as z from "zod";
import { isAllDigits, isValidCardName, isValidMonth, paymentValidationMessages, paymentValidationRules, } from "../../shared/paymentValidation";
export var paymentFormSchema = z.object({
    cardholderName: z
        .string()
        .refine(isValidCardName, paymentValidationMessages.cardholderName.invalidName)
        .optional(),
    cardNumber: z
        .string()
        .refine(isAllDigits, paymentValidationMessages.cardNumber.digitsOnly)
        .min(paymentValidationRules.cardNumber.minLength, paymentValidationMessages.cardNumber.minLength)
        .max(paymentValidationRules.cardNumber.maxLength, paymentValidationMessages.cardNumber.maxLength),
    expirationMonth: z
        .string()
        .refine(isAllDigits, paymentValidationMessages.expirationMonth.digitsOnly)
        .refine(isValidMonth, paymentValidationMessages.expirationMonth.invalidMonth)
        .length(paymentValidationRules.expirationMonth.length, paymentValidationMessages.expirationMonth.exactLength),
    expirationYear: z
        .string()
        .refine(isAllDigits, paymentValidationMessages.expirationYear.digitsOnly)
        .length(paymentValidationRules.expirationYear.length, paymentValidationMessages.expirationYear.exactLength),
    securityCode: z
        .string()
        .refine(isAllDigits, paymentValidationMessages.securityCode.digitsOnly)
        .min(paymentValidationRules.securityCode.minLength, paymentValidationMessages.securityCode.minLength)
        .max(paymentValidationRules.securityCode.maxLength, paymentValidationMessages.securityCode.maxLength),
});
